import React from 'react';
import { Box, Popover, SpaceBetween } from '@cloudscape-design/components';
const { projectedYearEndLabel } = require('../../../lib/budgetOverview');

export default function BudgetProjection({ projection, potName = 'Selected budget', showLabel = false }) {
  const available = projection?.status === 'available' && Number.isFinite(projection.projectedRemaining);
  const outcome = available ? projectedYearEndLabel(projection.projectedRemaining)
    : projection?.status === 'closed' ? 'Year ended' : 'Not enough data';
  const confidence = { low: 'Low confidence', moderate: 'Moderate confidence', high: 'High confidence' }[projection?.confidence];
  const explanation = projection?.explanation || 'A useful projection needs more recorded funding activity.';
  const detail = <SpaceBetween size="s">
    {!available && <Box>{explanation}</Box>}
    {projection?.asOf && <Box color="text-body-secondary" fontSize="body-s">As of {projection.asOf}.</Box>}
  </SpaceBetween>;
  return <SpaceBetween size="xxs">
    {showLabel && <Box variant="awsui-key-label">Projected Year End</Box>}
    {available ? <>
      <Box fontWeight="bold" color={projection.projectedRemaining < 0 ? 'text-status-error' : 'text-status-success'}>{outcome}</Box>
      <Box fontSize="body-s"><Popover renderWithPortal position="top" size="medium" header="Projected Year End"
        dismissAriaLabel="Close projection details" triggerAriaLabel={`${confidence || 'Projection details'} for ${potName}`} content={detail}>
        {confidence || 'Projection details'}
      </Popover></Box>
    </> : <Popover renderWithPortal position="top" size="medium" header="Projected Year End"
      dismissAriaLabel="Close projection details" triggerAriaLabel={`Projection details for ${potName}: ${outcome}`} content={detail}>
      {outcome}
    </Popover>}
  </SpaceBetween>;
}
